import { makeStyles } from "@mui/styles";

export default makeStyles(() => ({
  paper: {
    padding: "16px 8px",
    marginBottom: "24px",
  },
  paperHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
    borderBottom: "1px solid #e0e0e0",
    paddingBottom: "12px",
  },
  paperActionButtons: {
    display: "flex",
    gap: "4px",
  },
  title: {
    fontWeight: 600,
    marginBottom: "8px",
  },
  row: {
    marginBottom: "8px",
  },
  registerContainer: {
    padding: "8px",
  },
  noPadding: {
    padding: 0,
  },
  labTestDetailsContainer: {
    "@media print": {
      padding: "16px",
    },
  },
  printOnlyHeader: {
    display: "none",
    "@media print": {
      display: "block",
    },
  },
  labReportSubHeader: {
    marginTop: "12px",
    border: "1px dotted #999",
    padding: "8px",
  },
}));
